import React from 'react';
import { PRODUCT_STATES } from '../constants';

export default function MobileProductQuickFilters({ query, onChange }) {
  return (
    <div className='mp-quick-filters'>
      <label>
        <span>Статус</span>
        <select
          className='form-control form-control-sm'
          value={query.state.length > 1 ? '__MULTI__' : query.state[0] || ''}
          onChange={event => onChange({ state: event.target.value ? [event.target.value] : [] })}
        >
          {query.state.length > 1 && (
            <option value='__MULTI__' disabled>
              Обрано статусів: {query.state.length}
            </option>
          )}
          {PRODUCT_STATES.map(state => (
            <option key={state.value} value={state.value}>
              {state.label}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}
